import { render, staticRenderFns } from "./SinglePickerCard.vue?vue&type=template&id=2cfb0d70&"
import script from "./SinglePickerCard.vue?vue&type=script&lang=ts&"
export * from "./SinglePickerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports